<div class="row">
        <div class="col-12">
            <div class="table-responsive">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th class="col-options"></th>
                            <th class="col-atendente">Atendente</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entity of entities; let i = index">
                            <td class="col-options">
                                <a (click)="delete(i)">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="col-atendente">
                                <sgt-typeahead-usuario [(ngModel)]="entity.usuarioAtendente"  name="usuarioAtendente_{{i}}" id="usuarioAtendente_{{i}}"
                                    #usuarioAtendente="ngModel" [ngControl]="usuarioAtendente" [perfil]="4" [ativos]="true"
                                    (typeaheadChange)="onChangeUsuario(entity, $event)" [autofocus]="true">
                                </sgt-typeahead-usuario>
                            </td>
                        </tr>
                        <tr *ngIf="entities && entities.length === 0" class="no-record">
                            <td class="text-center" colspan="2">
                                <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                            </td>
                        </tr>
                    </tbody>
                    <tfoot class="table-footer">
                        <tr>
                            <td colspan="2">
                                <button type="button" class="btn btn-primary" (click)="insert()">
                                    <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Atendente
                                </button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
